module.exports = __webpack_public_path__ + "img/Desktop_Slide3.c34a848f.svg";